import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { DocumentActivityTypes } from "@ankaadia/ankaadia-shared";
import { NewUiButton } from "@ankaadia/ankaadia-shared-frontend";
import { NotificationScope, NotificationSettingsFragment } from "@ankaadia/graphql";
import { intersection } from "lodash";
import { FloatLabel } from "primeng/floatlabel";
import { Message } from "primeng/message";
import { map } from "rxjs";
import { NewUiCheckboxComponent } from "../../../shared/form/checkbox/new-ui-checkbox.component";
import { NewUiMultiselectComponent } from "../../../shared/form/multiselect/new-ui-multiselect.component";
import { valuesOf } from "../../../shared/services/form.helper";
import { StaticDataService } from "../../../shared/static-data/static-data.service";
import { TranslateDirective } from "../../../shared/transloco/translate.directive";
import { NewUiActivityTypeSelectorComponent } from "../../activity/activity-type-selector/new-ui-activity-type-selector.component";
import { NewUiDocumentTypeSelectorComponent } from "../../activity/document-type-selector/new-ui-document-type-selector.component";
import { NotificationSettingsFormService } from "./notification-configuration-form.service";

@Component({
  selector: "new-ui-notification-configuration",
  templateUrl: "./new-ui-notification-configuration.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslateDirective,
    ReactiveFormsModule,
    NewUiCheckboxComponent,
    Message,
    NewUiActivityTypeSelectorComponent,
    FloatLabel,
    NewUiButton,
    NewUiMultiselectComponent,
    NewUiDocumentTypeSelectorComponent,
  ],
})
export class NewUiNotificationConfigurationComponent implements OnInit {
  readonly form = this.formService.createForm();
  readonly scopes = this.staticDataService.transformEnumToStaticDataModel("NotificationScope", NotificationScope);

  @Input()
  set settings(settings: NotificationSettingsFragment) {
    this.form.reset(undefined, { emitEvent: false });
    this.form.patchValue(settings);
  }

  @Output()
  readonly changed = new EventEmitter<NotificationSettingsFragment>();

  @Output()
  readonly closed = new EventEmitter<void>();

  showDocumentTypeFilter: boolean;

  constructor(
    private readonly formService: NotificationSettingsFormService,
    private readonly staticDataService: StaticDataService
  ) {}

  ngOnInit(): void {
    valuesOf(this.form.controls.activities)
      .pipe(map((types) => types ?? []))
      .subscribe((types) => {
        if (!intersection(types, DocumentActivityTypes).length) {
          this.form.controls.documents.reset();
          this.showDocumentTypeFilter = false;
        } else {
          this.showDocumentTypeFilter = true;
        }
      });
  }

  save(): void {
    this.changed.emit(this.form.value);
    this.close();
  }

  close(): void {
    this.closed.emit();
  }
}
